module.exports = __webpack_public_path__ + "img/img3.9ac3bc91.jpg";